module.exports = __webpack_public_path__ + "media/images/pic/labels/a2_1-2a964e517c0b72ac69874f6583ca33c1.png";